import { getHourInNordics, isOutsideOpeningHours } from './util/time';

const initializePanelOpen = () => {
    const iimclient = window.iimclient;
    const myfullpath = iimclient.myfullpath;
    const minute = iimclient.now.getUTCMinutes();

    const closeCall = () => {
        window.dispatchEvent(new CustomEvent('setCallOpenVisible', { detail: false }));
        window.dispatchEvent(new CustomEvent('setCallClosedVisible', { detail: true }));
    };

    const handleClosing = (isClosed) => {
        if (iimclient.segment) return false;

        if (isClosed) iimclient.isClosed = true;

        const hour = getHourInNordics(iimclient.now);
        const day = iimclient.now.getUTCDay();

        if (
            isClosed ||
            (iimclient.lang == 'lang_no' &&
                (hour >= 21 ||
                    hour <= 7 ||
                    (day === 6 && hour >= 17) ||
                    (day == 6 && hour < 9) ||
                    (day === 0 && hour >= 19))) ||
            iimclient.callIsClosed
        ) {
            iimclient.callIsClosed = true;
            closeCall();
        } else {
            if (
                !(
                    isClosed ||
                    (iimclient.lang == 'lang_no' &&
                        (hour >= 21 ||
                            hour <= 7 ||
                            (day === 6 && hour >= 17) ||
                            (day === 0 && hour >= 19))) ||
                    iimclient.callIsClosed
                )
            ) {
                window.dispatchEvent(new CustomEvent('setCallClosedVisible', { detail: false }));
            } else {
                closeCall();
            }
        }
        if (iimclient.lang == 'lang_se' && iimclient.customerKey == 100110) {
            // Opening hours for Sweden Commercial is weekdays 0730-1900 and this have already been checked
        } else if (iimclient.lang == 'lang_dk') {
            if (/\?dkpriv/.test(myfullpath)) {
                // chat closes 10 minutes earlier
                if (
                    hour >= 20 ||
                    hour < 8 ||
                    (hour === 19 && minute >= 50) ||
                    (day === 5 && hour === 17 && minute >= 50) ||
                    (day === 6 && hour === 17 && minute >= 50) ||
                    (day === 0 && hour === 17 && minute >= 50)
                ) {
                    iimclient.callIsClosed = true;
                }
            }
        } else {
            // callback closes earlier also. Only checked when this method is called with isClosed===false
            if (isClosed || isOutsideOpeningHours(iimclient.now)) {
                window.dispatchEvent(new CustomEvent('setCallbackOpenVisible', { detail: false }));
            }
        }
    };
    iimclient.handleClosing = handleClosing;

    const checkOpen = () => {
        if (iimclient && iimclient.nopoll) {
            return;
        }
        if (!iimclient.timeId) {
            handleClosing(false);
            return;
        }

        window.PuzzelClient.timeExit(iimclient.customerKey, iimclient.timeId).then((t) => {
            const isClosed = t && t.Ok && t.Exit && !/open/i.test(t.Exit);
            handleClosing(isClosed);
        });
    };

    checkOpen();
};

const initializePanel = () => {
    const iimclient = window.iimclient;
    const isNoCom = iimclient.nocom;

    initializePanelOpen();

    if (window.ifhelp2015api) {
        window.ifhelp2015api.setFloaterIcons();
        window.ifhelp2015api.listenToMobilityUrlChanges();
    }

    const ifhelp2015ToggleWCB = () => {
        if (iimclient.displayCallbackForSegment) iimclient.displayCallbackForSegment();
        window.dispatchEvent(new CustomEvent('setActiveMenu', { detail: 'wcb' }));
        window.NordicTracking.eventInternalFormOpened(
            false,
            window.NordicTracking.PANELINFO_FUNCTION_NAME_PHONE
        );
    };

    if (!isNoCom && iimclient && iimclient.lang == 'lang_no') {
        if (document.querySelector('.wsno-cart-wrapper')) {
            document.body.classList.add('has-cart');
        }
    }

    if (!isNoCom && iimclient && (iimclient.lang == 'lang_se' || iimclient.lang == 'lang_dk')) {
        if (document.querySelector('.webshop-floating-summary.visible')) {
            document.body.classList.add('has-cart');
        }
    }

    const getContentElements = () => [
        ...document.querySelectorAll(
            '#ifhelp2015 .content-items, #ifhelp2015 .content-icons, #ifhelp2015 .content-buttons'
        ),
    ];

    const detectPriceSummary = () => {
        const priceSummary =
            document.querySelector('.sticky-bar.show-bottom') ||
            document.querySelector('pd-price-bar');

        if (priceSummary) {
            try {
                const style = window.getComputedStyle(priceSummary);
                const bottomPixels = parseInt(style.bottom.replace('px', ''));
                const heightPixels = parseInt(style.height.replace('px', ''));
                getContentElements().forEach(
                    (elem) => (elem.style.bottom = bottomPixels + heightPixels + 20 + 'px')
                );
            } catch {
                // do nothing
            }
        } else {
            getContentElements().forEach((elem) => elem.style.removeProperty('bottom'));
        }
    };

    const isSwedishWebshop = () =>
        /\.if\.se/.test(window.location.origin) && /webshop/.test(window.location.href);

    if (isSwedishWebshop()) {
        window.addEventListener('scroll', detectPriceSummary);
        detectPriceSummary();
    }

    const resetHash = (text) => {
        // Reset the hash so it can be invoked again
        if (text === 'web-callback') {
            iimclient.hadWebCallbackHash = Date.now();
            window.location.hash = window.location.hash.replace(text, '');
        }
    };

    const openChat = () => {
        const chatButton = document.getElementById('chat-menu-button');
        if (chatButton && chatButton.style.display !== 'none') {
            window.dispatchEvent(new CustomEvent('setActiveMenu', { detail: '' }));

            // Hash tag change allows us to open the chat for consecutive URL requests, because
            // we hook up the logic to 'hashchange' event.
            // For example, if there is a link with #human-chat hash tag it can be clicked multiple
            // times and it will open the human chat on every click.
            window.location.hash = window.location.hash.replace('human-chat', 'human-cc');

            if (window.vngage) window.vngage.evaluateOpportunities();
            setTimeout(() => {
                // Wait for solution evaluation & activation
                chatButton.click();
            }, 700);
        }
    };

    const openWCB = () => {
        const callButton = document.querySelector('.action.phone-button');
        if (callButton && callButton.style.display !== 'none') {
            ifhelp2015ToggleWCB();
            if (!iimclient.hadWebCallbackHash) {
                // Re-call hashCheck once after a timeout
                setTimeout(() => {
                    hashCheck();
                }, 500);
            }
        }
    };

    const hashCheck = () => {
        if (
            window.ifhelp2015api &&
            window.ifhelp2015api.hashCheckWCB &&
            window.ifhelp2015api.hashCheckWCB()
        ) {
            openWCB();
            resetHash('web-callback');
        }
        if (
            window.ifhelp2015api &&
            window.ifhelp2015api.hashCheckChat &&
            window.ifhelp2015api.hashCheckChat()
        ) {
            openChat();
        }
    };

    if (window.location.hash) hashCheck();
    setTimeout(() => {
        window.addEventListener('hashchange', hashCheck);
    }, 1);

    const updateVikingLinks = () => {
        if (!/if.se\/privat\/vid-skada\/chatt-motorskador-utomlands/.test(window.location.href))
            return;

        const ifLinks = document.querySelectorAll('a[href$=\\#if]');
        const imfLinks = document.querySelectorAll('a[href$=\\#imf]');
        const vrfLinks = document.querySelectorAll('a[href$=\\#vrf]');

        if (ifLinks.length) ifLinks[0].setAttribute('id', 'chat-link-if');
        if (imfLinks.length) imfLinks[0].setAttribute('id', 'chat-link-imf');
        if (vrfLinks.length) vrfLinks[0].setAttribute('id', 'chat-link-vrf');
    };

    updateVikingLinks();
};

const initializePanelQueueCheck = () => {
    const iimclient = window.iimclient;

    // original order of things:
    // 1. do/skip queue checks (agents logged on, etc.)
    // 2. do time module check for chat and phone

    // new order of things:
    // 1. do time module check for chat
    // 2. regardless of outcome of prior check, do/skip queue checks
    // 3. do time module check for phone

    // exactly the same as before, we just make sure to do time module check for chat prior to the queue check for chat
    // when the time module for chat is closed, the queue is closed - no but's and if's about that
    // Seeing as the queue can change to a different one during the time module check, it is important to do the queue checks afterward and not prior to the possible change

    const queueCheck = () => {
        const checkPhoneQueue = () => {
            if (
                iimclient.phoneVisualQueueId ||
                (iimclient.queues &&
                    iimclient.queues.default &&
                    iimclient.queues.default.phoneVisualQueueId)
            ) {
                const cKey =
                    iimclient.queues && iimclient.queues.default && iimclient.queues.default
                        ? iimclient.queues.default.customerKey
                        : iimclient.customerKey;
                const vqId =
                    iimclient.queues && iimclient.queues.default && iimclient.queues.default
                        ? iimclient.queues.default.phoneVisualQueueId
                        : iimclient.phoneVisualQueueId
                            ? iimclient.phoneVisualQueueId
                            : null;

                window.PuzzelClient.queueStatus(cKey, vqId).then((s) => {
                    if (s && s.Ok && s.Queue) {
                        const seconds = s.Queue.WaitTimeMax;
                        let timeStr = '';
                        if (seconds <= 30) timeStr = iimclient.texts['fewSeconds'];
                        else if (seconds <= 90) timeStr = iimclient.texts['oneMinute'];
                        else if (seconds <= 1800) {
                            //30min
                            timeStr =
                                (Math.floor(seconds / 60) > 1 ? Math.floor(seconds / 60) : 2) +
                                ' ' +
                                iimclient.texts['minutes'];
                        } else if (seconds <= 5400)
                            //1t30min
                            timeStr = iimclient.texts['oneHour'];
                        else if (seconds <= 9000)
                            //2t30min
                            timeStr = iimclient.texts['twoHours'];
                        else
                            timeStr =
                                (Math.floor(seconds / 3600) > 1 ? Math.floor(seconds / 3600) : 2) +
                                ' ' +
                                iimclient.texts['hours'];
                        iimclient.phoneWaitTimeText = timeStr;
                    } else {
                        iimclient.phoneWaitTimeText = '';
                        window.dispatchEvent(
                            new CustomEvent('setCallOpenVisible', { detail: false })
                        );
                    }
                });
            }
        };

        checkPhoneQueue();
    };

    queueCheck();
};

export { initializePanel, initializePanelQueueCheck };
